document.addEventListener('DOMContentLoaded', () => {
  const dropdowns = document.querySelectorAll('.in-page-nav-bar-dropdown');

  let lastIsWiderMobile = window.matchMedia('(min-width: 432px)').matches;
  let lastIsDesktop = window.matchMedia('(min-width: 960px)').matches;

  const isWiderMobile = () => window.matchMedia('(min-width: 432px)').matches;
  const isDesktop = () => window.matchMedia('(min-width: 960px)').matches;

  const closeAllDropdowns = () => {
    dropdowns.forEach((dropdown) => {
      const button = dropdown.querySelector('button');
      const list = dropdown.querySelector('[role="menu"]');
      dropdown.classList.remove('is-open');
      button?.setAttribute('aria-expanded', 'false');
      list?.setAttribute('inert', '');
    });
  };

  dropdowns.forEach((dropdown) => {
    const button = dropdown.querySelector('button');
    const popupId = button?.getAttribute('aria-controls');
    const list = popupId ? document.getElementById(popupId) : dropdown.querySelector('[role="menu"]');

    if (!button || !list) return;

    const getItems = () => Array.from(list.querySelectorAll('a, button'));

    const open = () => {
      dropdown.classList.add('is-open');
      button.setAttribute('aria-expanded', 'true');
      list.removeAttribute('inert');
    };

    const close = () => {
      dropdown.classList.remove('is-open');
      button.setAttribute('aria-expanded', 'false');
      list.setAttribute('inert', '');
    };

    const closeAllExcept = (exclude) => {
      if (!isWiderMobile()) return;

      dropdowns.forEach((other) => {
        if (other !== exclude) {
          const otherButton = other.querySelector('button');
          const otherList = other.querySelector('[role="menu"]');
          other.classList.remove('is-open');
          otherButton?.setAttribute('aria-expanded', 'false');
          otherList?.setAttribute('inert', '');
        }
      });
    };

    const focusItem = (index) => {
      const items = getItems();
      if (items.length > 0) {
        items[(index + items.length) % items.length].focus();
      }
    };

    button.addEventListener('click', (e) => {
      e.preventDefault();
      const isOpen = dropdown.classList.contains('is-open');

      if (!isOpen) {
        closeAllExcept(dropdown);
        open();
        if (e.detail === 0) { // Keyboard-initiated
          list.focus();
        }
      } else {
        close();
      }
    });

    button.addEventListener('keydown', (e) => {
      const items = getItems();

      switch (e.key) {
        case 'ArrowDown':
        case ' ':
        case 'Enter':
          e.preventDefault();
          closeAllExcept(dropdown);
          open();
          focusItem(0);
          break;
        case 'ArrowUp':
          e.preventDefault();
          closeAllExcept(dropdown);
          open();
          focusItem(items.length - 1);
          break;
      }
    });

    list.addEventListener('keydown', (e) => {
      const items = getItems();
      const currentIndex = items.indexOf(document.activeElement);

      switch (e.key) {
        case 'ArrowDown':
        case 'ArrowRight':
          e.preventDefault();
          focusItem(currentIndex + 1);
          break;
        case 'ArrowUp':
        case 'ArrowLeft':
          e.preventDefault();
          focusItem(currentIndex - 1);
          break;
        case 'Tab':
          if (e.shiftKey) {
            e.preventDefault();
            focusItem(currentIndex - 1);
          } else {
            e.preventDefault();
            focusItem(currentIndex + 1);
          }
          break;
        case 'Escape':
          e.preventDefault();
          close();
          button.focus();
          break;
      }
    });

    document.addEventListener('mousedown', (e) => {
      if (!isDesktop()) return;

      if (
        dropdown.classList.contains('is-open') &&
        !dropdown.contains(e.target)
      ) {
        close();
      }
    });

    // Initialize ARIA state
    button.setAttribute('aria-expanded', 'false');
    list.setAttribute('inert', '');
  });

  // Close dropdowns when crossing breakpoints
  window.addEventListener('resize', () => {
    const currentWiderMobile = isWiderMobile();
    const currentDesktop = isDesktop();

    if (
      currentWiderMobile !== lastIsWiderMobile ||
      currentDesktop !== lastIsDesktop
    ) {
      closeAllDropdowns();
      lastIsWiderMobile = currentWiderMobile;
      lastIsDesktop = currentDesktop;
    }
  });
});
